import { Box } from "@bca/ui-library";

import FilterCategories from "./FilterCategories";

interface Props {
  setSelectedVehicles: (selectedVehicles: string[]) => void;
  appliedCheckboxes: any;
  setAppliedCheckboxes: any;
  searchResultsLoading: boolean;
}

const FiltersBarDesktop: React.FC<Props> = ({
  setSelectedVehicles,
  appliedCheckboxes,
  setAppliedCheckboxes,
  searchResultsLoading,
}) => (
  <Box as="aside" backgroundColor="primary-white">
    <FilterCategories
      setSelectedVehicles={setSelectedVehicles}
      appliedCheckboxes={appliedCheckboxes}
      setAppliedCheckboxes={setAppliedCheckboxes}
      searchResultsLoading={searchResultsLoading}
    />
  </Box>
);

export default FiltersBarDesktop;
